import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { WorkSpaceService } from '@app/features/workspace/services/workspace.service';
import { AvatarStack } from '@shared/components/avatar-stack/avatar-stack';
import { Spinner } from '@shared/components/spinner/spinner';

@Component({
  selector: 'app-list-item-selector',
  imports: [CommonModule , RouterModule , AvatarStack, Spinner],
  templateUrl: './list-item-selector.html',
  styleUrl: './list-item-selector.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemSelector {
  @Output() redirectTo = new EventEmitter<any>();
  @Output() editWorkspace = new EventEmitter<any>();
  @Input() isShowEditIcon : boolean;
  @Input() wrapperClass : string;
  @Input() loader : boolean;
  @Input() defaultImage;
  @Input() items;
  workspaceLoader  = input<boolean>(false);
  addButtonLabel = input<string>('Create New Workspace');
  showMemberDetail = input<boolean>(true);
  showRemoveLink = input<boolean>(false);
  addButtonIcon = input<string>('assets/icons/fa-plus.svg');
  constructor(private workSpaceService : WorkSpaceService , private route : ActivatedRoute){}
  isActiveWorkSpace(workspace) {
  const workspaceId = this.route.snapshot.paramMap.get('id');
   return this.isShowEditIcon && workspace?.id === workspaceId
  }
  emitWorkSpaceEvent(event : MouseEvent, action : string , workSpace?: any) {
    event.stopPropagation();
    this.redirectTo.emit({action : action, data : workSpace})
  }
   get activeWorkspace() : any {
    return this.workSpaceService.activeWorkspace();
  }
  editEvent(event : any , workspaceId) {
    event.stopPropagation();
    this.editWorkspace.emit(workspaceId)
  }
}
